<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter >
      <wt-table :labels="tableLabels" :list="tableData">
          <slot/>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-group-table'

export default {
  name: 'pt-group-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    getGoodsList: {
      type: Function
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      pageLayout: 'total, prev, pager, next,jumper',
      table_data: this.tableData
    }
  },
  watch: {
    tableData: {
      handler: function (val) {
        this.table_data = val
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('get-group-list', page, next)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
